// The 80s catalog for Cruz's Movie Night — 724 popular films, 1980–1989,
// titles and years only (never links: the host pastes whatever URL they have
// the right to watch). Built 2026-09-01 by an 8-lane genre sweep with every
// release year verified against the web, merged and deduped (Haley: "ALL
// popular 80s movies not just 40"). Genre tags let Cruz theme a week —
// three horror picks for Halloween — and rotate so a run of nights never
// feels samey. Keep this file and the Deno copy in the movie-night-tick edge
// function identical: the scheduler picks on the server, the card renders on
// the client, and a title that exists in one and not the other is a bug.
//
// Vocabulary: action, adventure, animation, comedy, crime, cult, drama, family, fantasy, horror, musical, romance, scifi, sports, teen, thriller, war.
export const EIGHTIES_GENRES = ["action", "adventure", "animation", "comedy", "crime", "cult", "drama", "family", "fantasy", "horror", "musical", "romance", "scifi", "sports", "teen", "thriller", "war"];

export const EIGHTIES_CATALOG = [
  { title: "9 to 5", year: 1980, genres: ["comedy"] },
  { title: "Airplane!", year: 1980, genres: ["comedy", "cult"] },
  { title: "Altered States", year: 1980, genres: ["scifi", "horror", "drama"] },
  { title: "American Gigolo", year: 1980, genres: ["drama", "crime"] },
  { title: "Any Which Way You Can", year: 1980, genres: ["comedy", "action"] },
  { title: "Atlantic City", year: 1980, genres: ["crime", "drama", "romance"] },
  { title: "Bon Voyage, Charlie Brown (and Don't Come Back!!)", year: 1980, genres: ["animation", "family", "comedy"] },
  { title: "Breaker Morant", year: 1980, genres: ["war", "drama"] },
  { title: "Brubaker", year: 1980, genres: ["drama", "crime"] },
  { title: "Caddyshack", year: 1980, genres: ["comedy", "sports", "cult"] },
  { title: "Can't Stop the Music", year: 1980, genres: ["musical", "comedy", "cult"] },
  { title: "Cannibal Holocaust", year: 1980, genres: ["horror", "cult"] },
  { title: "Coal Miner's Daughter", year: 1980, genres: ["drama", "musical"] },
  { title: "Dressed to Kill", year: 1980, genres: ["thriller", "horror", "crime"] },
  { title: "Fame", year: 1980, genres: ["musical", "drama", "teen"] },
  { title: "Flash Gordon", year: 1980, genres: ["scifi", "adventure", "cult"] },
  { title: "Friday the 13th", year: 1980, genres: ["horror", "teen", "cult"] },
  { title: "Gloria", year: 1980, genres: ["crime", "drama"] },
  { title: "Heaven's Gate", year: 1980, genres: ["drama", "cult"] },
  { title: "Herbie Goes Bananas", year: 1980, genres: ["family", "comedy"] },
  { title: "Kagemusha", year: 1980, genres: ["war", "drama"] },
  { title: "My Bodyguard", year: 1980, genres: ["teen", "drama"] },
  { title: "Ordinary People", year: 1980, genres: ["drama"] },
  { title: "Popeye", year: 1980, genres: ["fantasy", "musical", "comedy"] },
  { title: "Private Benjamin", year: 1980, genres: ["comedy"] },
  { title: "Prom Night", year: 1980, genres: ["horror", "teen"] },
  { title: "Raging Bull", year: 1980, genres: ["drama", "sports"] },
  { title: "Seems Like Old Times", year: 1980, genres: ["comedy", "romance"] },
  { title: "Smokey and the Bandit II", year: 1980, genres: ["comedy", "action"] },
  { title: "Somewhere in Time", year: 1980, genres: ["fantasy", "romance", "drama"] },
  { title: "Stir Crazy", year: 1980, genres: ["comedy", "crime"] },
  { title: "Superman II", year: 1980, genres: ["action", "fantasy", "adventure"] },
  { title: "Terror Train", year: 1980, genres: ["horror", "thriller"] },
  { title: "The Apple", year: 1980, genres: ["musical", "scifi", "cult"] },
  { title: "The Big Red One", year: 1980, genres: ["war", "drama"] },
  { title: "The Blue Lagoon", year: 1980, genres: ["romance", "drama", "adventure"] },
  { title: "The Blues Brothers", year: 1980, genres: ["comedy", "musical", "cult"] },
  { title: "The Changeling", year: 1980, genres: ["horror", "thriller"] },
  { title: "The Elephant Man", year: 1980, genres: ["drama"] },
  { title: "The Empire Strikes Back", year: 1980, genres: ["scifi", "adventure", "fantasy"] },
  { title: "The Final Countdown", year: 1980, genres: ["scifi", "war", "action"] },
  { title: "The Fog", year: 1980, genres: ["horror", "thriller"] },
  { title: "The Jazz Singer", year: 1980, genres: ["musical", "drama"] },
  { title: "The Long Good Friday", year: 1980, genres: ["crime", "thriller"] },
  { title: "The Shining", year: 1980, genres: ["horror", "thriller", "drama"] },
  { title: "The Watcher in the Woods", year: 1980, genres: ["horror", "family", "thriller"] },
  { title: "Urban Cowboy", year: 1980, genres: ["romance", "drama"] },
  { title: "Used Cars", year: 1980, genres: ["comedy", "cult"] },
  { title: "Xanadu", year: 1980, genres: ["fantasy", "musical", "romance"] },
  { title: "Absence of Malice", year: 1981, genres: ["drama", "thriller"] },
  { title: "American Pop", year: 1981, genres: ["animation", "musical", "cult"] },
  { title: "An American Werewolf in London", year: 1981, genres: ["horror", "comedy"] },
  { title: "Arthur", year: 1981, genres: ["comedy", "romance"] },
  { title: "Blow Out", year: 1981, genres: ["thriller", "crime"] },
  { title: "Body Heat", year: 1981, genres: ["thriller", "romance", "crime"] },
  { title: "Chariots of Fire", year: 1981, genres: ["drama", "sports"] },
  { title: "Clash of the Titans", year: 1981, genres: ["fantasy", "adventure"] },
  { title: "Condorman", year: 1981, genres: ["family", "comedy", "action"] },
  { title: "Das Boot", year: 1981, genres: ["war", "drama", "thriller"] },
  { title: "Dragonslayer", year: 1981, genres: ["fantasy", "adventure"] },
  { title: "Endless Love", year: 1981, genres: ["romance", "drama", "teen"] },
  { title: "Escape from New York", year: 1981, genres: ["action", "scifi", "cult"] },
  { title: "Excalibur", year: 1981, genres: ["fantasy", "adventure", "drama"] },
  { title: "Eye of the Needle", year: 1981, genres: ["thriller", "war"] },
  { title: "For Your Eyes Only", year: 1981, genres: ["action", "adventure", "thriller"] },
  { title: "Fort Apache, The Bronx", year: 1981, genres: ["crime", "drama"] },
  { title: "Friday the 13th Part 2", year: 1981, genres: ["horror", "teen"] },
  { title: "Gallipoli", year: 1981, genres: ["war", "drama"] },
  { title: "Halloween II", year: 1981, genres: ["horror", "thriller"] },
  { title: "Heavy Metal", year: 1981, genres: ["animation", "scifi", "fantasy"] },
  { title: "History of the World, Part I", year: 1981, genres: ["comedy"] },
  { title: "My Bloody Valentine", year: 1981, genres: ["horror", "cult"] },
  { title: "Neighbors", year: 1981, genres: ["comedy"] },
  { title: "Nighthawks", year: 1981, genres: ["action", "thriller", "crime"] },
  { title: "On Golden Pond", year: 1981, genres: ["drama"] },
  { title: "Outland", year: 1981, genres: ["scifi", "action", "thriller"] },
  { title: "Pennies from Heaven", year: 1981, genres: ["musical", "drama"] },
  { title: "Porky's", year: 1981, genres: ["teen", "comedy"] },
  { title: "Prince of the City", year: 1981, genres: ["crime", "drama"] },
  { title: "Ragtime", year: 1981, genres: ["drama"] },
  { title: "Raiders of the Lost Ark", year: 1981, genres: ["action", "adventure"] },
  { title: "Reds", year: 1981, genres: ["drama", "romance", "war"] },
  { title: "Scanners", year: 1981, genres: ["scifi", "horror", "cult"] },
  { title: "Shock Treatment", year: 1981, genres: ["musical", "comedy", "cult"] },
  { title: "Stripes", year: 1981, genres: ["comedy", "war"] },
  { title: "Taps", year: 1981, genres: ["drama", "teen"] },
  { title: "The Cannonball Run", year: 1981, genres: ["comedy", "action"] },
  { title: "The Evil Dead", year: 1981, genres: ["horror", "cult"] },
  { title: "The Four Seasons", year: 1981, genres: ["comedy", "drama"] },
  { title: "The Fox and the Hound", year: 1981, genres: ["animation", "family", "drama"] },
  { title: "The French Lieutenant's Woman", year: 1981, genres: ["romance", "drama"] },
  { title: "The Great Muppet Caper", year: 1981, genres: ["family", "musical", "comedy"] },
  { title: "The Howling", year: 1981, genres: ["horror", "thriller"] },
  { title: "The Postman Always Rings Twice", year: 1981, genres: ["crime", "drama", "romance"] },
  { title: "Thief", year: 1981, genres: ["crime", "thriller"] },
  { title: "Time Bandits", year: 1981, genres: ["fantasy", "adventure", "comedy"] },
  { title: "Victory", year: 1981, genres: ["war", "sports", "drama"] },
  { title: "48 Hrs.", year: 1982, genres: ["action", "comedy", "crime"] },
  { title: "Airplane II: The Sequel", year: 1982, genres: ["comedy", "scifi"] },
  { title: "An Officer and a Gentleman", year: 1982, genres: ["romance", "drama"] },
  { title: "Annie", year: 1982, genres: ["musical", "family"] },
  { title: "Blade Runner", year: 1982, genres: ["scifi", "thriller", "cult"] },
  { title: "Cat People", year: 1982, genres: ["fantasy", "horror", "thriller"] },
  { title: "Conan the Barbarian", year: 1982, genres: ["action", "fantasy", "adventure"] },
  { title: "Creepshow", year: 1982, genres: ["horror", "comedy", "cult"] },
  { title: "Death Wish II", year: 1982, genres: ["action", "crime", "thriller"] },
  { title: "Deathtrap", year: 1982, genres: ["thriller", "comedy"] },
  { title: "Diner", year: 1982, genres: ["comedy", "drama"] },
  { title: "E.T. the Extra-Terrestrial", year: 1982, genres: ["scifi", "family", "drama"] },
  { title: "Fanny and Alexander", year: 1982, genres: ["drama"] },
  { title: "Fast Times at Ridgemont High", year: 1982, genres: ["teen", "comedy", "romance"] },
  { title: "Firefox", year: 1982, genres: ["action", "thriller", "scifi"] },
  { title: "First Blood", year: 1982, genres: ["action", "thriller", "drama"] },
  { title: "Fitzcarraldo", year: 1982, genres: ["adventure", "drama"] },
  { title: "Frances", year: 1982, genres: ["drama"] },
  { title: "Friday the 13th Part III", year: 1982, genres: ["horror", "teen"] },
  { title: "Gandhi", year: 1982, genres: ["drama"] },
  { title: "Grease 2", year: 1982, genres: ["musical", "teen", "romance"] },
  { title: "Halloween III: Season of the Witch", year: 1982, genres: ["horror", "scifi", "cult"] },
  { title: "Missing", year: 1982, genres: ["drama", "thriller"] },
  { title: "My Favorite Year", year: 1982, genres: ["comedy"] },
  { title: "Night Shift", year: 1982, genres: ["comedy"] },
  { title: "Pink Floyd – The Wall", year: 1982, genres: ["musical", "drama", "cult"] },
  { title: "Poltergeist", year: 1982, genres: ["horror", "fantasy", "family"] },
  { title: "Rocky III", year: 1982, genres: ["sports", "drama"] },
  { title: "Sophie's Choice", year: 1982, genres: ["drama", "romance"] },
  { title: "Star Trek II: The Wrath of Khan", year: 1982, genres: ["scifi", "adventure", "action"] },
  { title: "Swamp Thing", year: 1982, genres: ["scifi", "horror", "cult"] },
  { title: "The Beastmaster", year: 1982, genres: ["fantasy", "adventure", "cult"] },
  { title: "The Best Little Whorehouse in Texas", year: 1982, genres: ["comedy", "musical"] },
  { title: "The Dark Crystal", year: 1982, genres: ["fantasy", "adventure", "family"] },
  { title: "The King of Comedy", year: 1982, genres: ["comedy", "drama", "cult"] },
  { title: "The Last American Virgin", year: 1982, genres: ["teen", "comedy", "drama"] },
  { title: "The Last Unicorn", year: 1982, genres: ["animation", "fantasy", "family"] },
  { title: "The Man from Snowy River", year: 1982, genres: ["adventure", "romance", "drama"] },
  { title: "The Plague Dogs", year: 1982, genres: ["animation", "drama"] },
  { title: "The Secret of NIMH", year: 1982, genres: ["animation", "fantasy", "family"] },
  { title: "The Thing", year: 1982, genres: ["scifi", "horror", "cult"] },
  { title: "The Toy", year: 1982, genres: ["comedy", "family"] },
  { title: "The Verdict", year: 1982, genres: ["drama", "crime"] },
  { title: "The World According to Garp", year: 1982, genres: ["comedy", "drama"] },
  { title: "The Year of Living Dangerously", year: 1982, genres: ["romance", "drama", "thriller"] },
  { title: "Tootsie", year: 1982, genres: ["comedy", "romance", "drama"] },
  { title: "Tron", year: 1982, genres: ["scifi", "adventure", "cult"] },
  { title: "Victor/Victoria", year: 1982, genres: ["musical", "comedy", "romance"] },
  { title: "A Christmas Story", year: 1983, genres: ["comedy", "family"] },
  { title: "All the Right Moves", year: 1983, genres: ["teen", "sports", "drama"] },
  { title: "Bad Boys", year: 1983, genres: ["crime", "drama", "teen"] },
  { title: "Blue Thunder", year: 1983, genres: ["action", "thriller"] },
  { title: "BMX Bandits", year: 1983, genres: ["adventure", "family"] },
  { title: "Brainstorm", year: 1983, genres: ["scifi", "thriller", "drama"] },
  { title: "Christine", year: 1983, genres: ["horror", "teen", "thriller"] },
  { title: "Class", year: 1983, genres: ["teen", "comedy", "drama"] },
  { title: "Cujo", year: 1983, genres: ["horror", "thriller"] },
  { title: "Easy Money", year: 1983, genres: ["comedy"] },
  { title: "Educating Rita", year: 1983, genres: ["comedy", "drama"] },
  { title: "Fire and Ice", year: 1983, genres: ["animation", "fantasy", "cult"] },
  { title: "Flashdance", year: 1983, genres: ["romance", "drama", "musical"] },
  { title: "Gorky Park", year: 1983, genres: ["thriller", "crime"] },
  { title: "Jaws 3-D", year: 1983, genres: ["horror", "thriller"] },
  { title: "Krull", year: 1983, genres: ["fantasy", "scifi", "cult"] },
  { title: "Local Hero", year: 1983, genres: ["comedy", "drama"] },
  { title: "Lone Wolf McQuade", year: 1983, genres: ["action", "cult"] },
  { title: "Merry Christmas, Mr. Lawrence", year: 1983, genres: ["war", "drama"] },
  { title: "Mr. Mom", year: 1983, genres: ["comedy", "family"] },
  { title: "National Lampoon's Vacation", year: 1983, genres: ["comedy", "family"] },
  { title: "Never Cry Wolf", year: 1983, genres: ["drama", "adventure", "family"] },
  { title: "Never Say Never Again", year: 1983, genres: ["action", "adventure", "thriller"] },
  { title: "Octopussy", year: 1983, genres: ["action", "adventure", "thriller"] },
  { title: "Porky's II: The Next Day", year: 1983, genres: ["teen", "comedy"] },
  { title: "Psycho II", year: 1983, genres: ["horror", "thriller"] },
  { title: "Return of the Jedi", year: 1983, genres: ["scifi", "adventure", "fantasy"] },
  { title: "Risky Business", year: 1983, genres: ["teen", "comedy", "romance"] },
  { title: "Rumble Fish", year: 1983, genres: ["teen", "drama", "cult"] },
  { title: "Scarface", year: 1983, genres: ["crime", "drama"] },
  { title: "Silkwood", year: 1983, genres: ["drama", "thriller"] },
  { title: "Sleepaway Camp", year: 1983, genres: ["horror", "teen", "cult"] },
  { title: "Something Wicked This Way Comes", year: 1983, genres: ["fantasy", "horror", "family"] },
  { title: "Staying Alive", year: 1983, genres: ["musical", "drama"] },
  { title: "Strange Brew", year: 1983, genres: ["comedy", "cult"] },
  { title: "Sudden Impact", year: 1983, genres: ["action", "crime", "thriller"] },
  { title: "Superman III", year: 1983, genres: ["action", "fantasy", "comedy"] },
  { title: "Tender Mercies", year: 1983, genres: ["drama"] },
  { title: "Terms of Endearment", year: 1983, genres: ["drama", "romance", "comedy"] },
  { title: "The Big Chill", year: 1983, genres: ["drama", "comedy"] },
  { title: "The Black Stallion Returns", year: 1983, genres: ["family", "adventure"] },
  { title: "The Dead Zone", year: 1983, genres: ["fantasy", "thriller", "horror"] },
  { title: "The Dresser", year: 1983, genres: ["drama"] },
  { title: "The Hunger", year: 1983, genres: ["horror", "romance", "cult"] },
  { title: "The Man with Two Brains", year: 1983, genres: ["comedy", "scifi"] },
  { title: "The Outsiders", year: 1983, genres: ["teen", "drama", "crime"] },
  { title: "The Right Stuff", year: 1983, genres: ["drama", "adventure"] },
  { title: "Trading Places", year: 1983, genres: ["comedy"] },
  { title: "Twilight Zone: The Movie", year: 1983, genres: ["fantasy", "horror", "scifi"] },
  { title: "Two of a Kind", year: 1983, genres: ["comedy", "romance", "fantasy"] },
  { title: "Uncommon Valor", year: 1983, genres: ["action", "war"] },
  { title: "Valley Girl", year: 1983, genres: ["teen", "romance", "comedy"] },
  { title: "Videodrome", year: 1983, genres: ["scifi", "horror", "cult"] },
  { title: "WarGames", year: 1983, genres: ["teen", "thriller", "scifi"] },
  { title: "Yentl", year: 1983, genres: ["musical", "romance", "drama"] },
  { title: "Zelig", year: 1983, genres: ["comedy"] },
  { title: "2010: The Year We Make Contact", year: 1984, genres: ["scifi", "drama"] },
  { title: "A Nightmare on Elm Street", year: 1984, genres: ["horror", "teen"] },
  { title: "A Passage to India", year: 1984, genres: ["drama"] },
  { title: "A Soldier's Story", year: 1984, genres: ["drama", "crime"] },
  { title: "Against All Odds", year: 1984, genres: ["thriller", "romance", "crime"] },
  { title: "All of Me", year: 1984, genres: ["fantasy", "comedy", "romance"] },
  { title: "Amadeus", year: 1984, genres: ["drama", "musical"] },
  { title: "Bachelor Party", year: 1984, genres: ["comedy"] },
  { title: "Beat Street", year: 1984, genres: ["musical", "drama", "teen"] },
  { title: "Beverly Hills Cop", year: 1984, genres: ["action", "comedy", "crime"] },
  { title: "Birdy", year: 1984, genres: ["drama", "war"] },
  { title: "Blame It on Rio", year: 1984, genres: ["comedy", "romance"] },
  { title: "Blood Simple", year: 1984, genres: ["crime", "thriller", "cult"] },
  { title: "Body Double", year: 1984, genres: ["thriller", "cult"] },
  { title: "Breakin'", year: 1984, genres: ["musical", "teen", "drama"] },
  { title: "Breakin' 2: Electric Boogaloo", year: 1984, genres: ["musical", "comedy", "cult"] },
  { title: "Broadway Danny Rose", year: 1984, genres: ["comedy"] },
  { title: "C.H.U.D.", year: 1984, genres: ["horror", "scifi", "cult"] },
  { title: "Cannonball Run II", year: 1984, genres: ["comedy", "action"] },
  { title: "Children of the Corn", year: 1984, genres: ["horror", "thriller"] },
  { title: "Conan the Destroyer", year: 1984, genres: ["action", "fantasy", "adventure"] },
  { title: "Dreamscape", year: 1984, genres: ["scifi", "thriller", "fantasy"] },
  { title: "Dune", year: 1984, genres: ["scifi", "adventure", "cult"] },
  { title: "Electric Dreams", year: 1984, genres: ["scifi", "romance", "comedy"] },
  { title: "Falling in Love", year: 1984, genres: ["romance", "drama"] },
  { title: "Firestarter", year: 1984, genres: ["scifi", "horror", "thriller"] },
  { title: "Footloose", year: 1984, genres: ["teen", "musical", "drama"] },
  { title: "Friday the 13th: The Final Chapter", year: 1984, genres: ["horror", "teen"] },
  { title: "Ghostbusters", year: 1984, genres: ["comedy", "fantasy", "adventure"] },
  { title: "Gremlins", year: 1984, genres: ["fantasy", "comedy", "horror"] },
  { title: "Greystoke: The Legend of Tarzan, Lord of the Apes", year: 1984, genres: ["adventure", "drama"] },
  { title: "Indiana Jones and the Temple of Doom", year: 1984, genres: ["action", "adventure"] },
  { title: "Johnny Dangerously", year: 1984, genres: ["comedy", "crime"] },
  { title: "Micki & Maude", year: 1984, genres: ["comedy", "romance"] },
  { title: "Missing in Action", year: 1984, genres: ["action", "war"] },
  { title: "Moscow on the Hudson", year: 1984, genres: ["comedy", "drama", "romance"] },
  { title: "Nausicaä of the Valley of the Wind", year: 1984, genres: ["animation", "scifi", "fantasy"] },
  { title: "Night of the Comet", year: 1984, genres: ["scifi", "horror", "cult"] },
  { title: "Once Upon a Time in America", year: 1984, genres: ["crime", "drama"] },
  { title: "Paris, Texas", year: 1984, genres: ["drama"] },
  { title: "Places in the Heart", year: 1984, genres: ["drama"] },
  { title: "Police Academy", year: 1984, genres: ["comedy"] },
  { title: "Purple Rain", year: 1984, genres: ["musical", "romance", "drama"] },
  { title: "Red Dawn", year: 1984, genres: ["action", "war", "teen"] },
  { title: "Repo Man", year: 1984, genres: ["scifi", "comedy", "cult"] },
  { title: "Revenge of the Nerds", year: 1984, genres: ["comedy", "teen"] },
  { title: "Romancing the Stone", year: 1984, genres: ["adventure", "romance", "comedy"] },
  { title: "Silent Night, Deadly Night", year: 1984, genres: ["horror", "cult"] },
  { title: "Sixteen Candles", year: 1984, genres: ["teen", "comedy", "romance"] },
  { title: "Splash", year: 1984, genres: ["fantasy", "romance", "comedy"] },
  { title: "Star Trek III: The Search for Spock", year: 1984, genres: ["scifi", "adventure"] },
  { title: "Starman", year: 1984, genres: ["scifi", "romance", "drama"] },
  { title: "Streets of Fire", year: 1984, genres: ["action", "musical", "cult"] },
  { title: "Supergirl", year: 1984, genres: ["fantasy", "action", "cult"] },
  { title: "The Adventures of Buckaroo Banzai Across the 8th Dimension", year: 1984, genres: ["scifi", "adventure", "cult"] },
  { title: "The Bounty", year: 1984, genres: ["adventure", "drama"] },
  { title: "The Cotton Club", year: 1984, genres: ["crime", "drama", "musical"] },
  { title: "The Flamingo Kid", year: 1984, genres: ["comedy", "drama", "teen"] },
  { title: "The Karate Kid", year: 1984, genres: ["teen", "sports", "drama"] },
  { title: "The Killing Fields", year: 1984, genres: ["war", "drama"] },
  { title: "The Last Starfighter", year: 1984, genres: ["scifi", "adventure", "teen"] },
  { title: "The Muppets Take Manhattan", year: 1984, genres: ["family", "musical", "comedy"] },
  { title: "The Natural", year: 1984, genres: ["sports", "drama"] },
  { title: "The NeverEnding Story", year: 1984, genres: ["fantasy", "adventure", "family"] },
  { title: "The Philadelphia Experiment", year: 1984, genres: ["scifi", "thriller", "romance"] },
  { title: "The Pope of Greenwich Village", year: 1984, genres: ["crime", "drama"] },
  { title: "The Terminator", year: 1984, genres: ["action", "scifi", "thriller"] },
  { title: "The Toxic Avenger", year: 1984, genres: ["scifi", "comedy", "cult"] },
  { title: "The Woman in Red", year: 1984, genres: ["comedy", "romance"] },
  { title: "This Is Spinal Tap", year: 1984, genres: ["comedy", "musical", "cult"] },
  { title: "Tightrope", year: 1984, genres: ["thriller", "crime"] },
  { title: "Top Secret!", year: 1984, genres: ["comedy", "cult"] },
  { title: "A Chorus Line", year: 1985, genres: ["musical", "drama"] },
  { title: "A Nightmare on Elm Street 2: Freddy's Revenge", year: 1985, genres: ["horror", "teen"] },
  { title: "A Room with a View", year: 1985, genres: ["romance", "drama"] },
  { title: "A View to a Kill", year: 1985, genres: ["action", "adventure", "thriller"] },
  { title: "American Ninja", year: 1985, genres: ["action", "cult"] },
  { title: "Back to the Future", year: 1985, genres: ["scifi", "adventure", "comedy"] },
  { title: "Better Off Dead", year: 1985, genres: ["teen", "comedy", "cult"] },
  { title: "Brazil", year: 1985, genres: ["scifi", "comedy", "cult"] },
  { title: "Brewster's Millions", year: 1985, genres: ["comedy"] },
  { title: "Cat's Eye", year: 1985, genres: ["horror", "fantasy"] },
  { title: "Clue", year: 1985, genres: ["comedy", "crime", "cult"] },
  { title: "Cocoon", year: 1985, genres: ["scifi", "drama", "comedy"] },
  { title: "Code of Silence", year: 1985, genres: ["action", "crime"] },
  { title: "Come and See", year: 1985, genres: ["war", "drama"] },
  { title: "Commando", year: 1985, genres: ["action"] },
  { title: "D.A.R.Y.L.", year: 1985, genres: ["scifi", "family", "drama"] },
  { title: "Day of the Dead", year: 1985, genres: ["horror", "scifi"] },
  { title: "Death Wish 3", year: 1985, genres: ["action", "crime", "cult"] },
  { title: "Demons", year: 1985, genres: ["horror", "cult"] },
  { title: "Desert Hearts", year: 1985, genres: ["romance", "drama", "cult"] },
  { title: "Desperately Seeking Susan", year: 1985, genres: ["comedy", "romance", "cult"] },
  { title: "Enemy Mine", year: 1985, genres: ["scifi", "drama", "adventure"] },
  { title: "Explorers", year: 1985, genres: ["scifi", "adventure", "family"] },
  { title: "Fletch", year: 1985, genres: ["comedy", "crime"] },
  { title: "Friday the 13th: A New Beginning", year: 1985, genres: ["horror", "teen"] },
  { title: "Fright Night", year: 1985, genres: ["horror", "teen", "comedy"] },
  { title: "Ghoulies", year: 1985, genres: ["horror", "comedy", "cult"] },
  { title: "Girls Just Want to Have Fun", year: 1985, genres: ["teen", "comedy", "musical"] },
  { title: "He-Man and She-Ra: The Secret of the Sword", year: 1985, genres: ["animation", "family", "fantasy"] },
  { title: "Invasion U.S.A.", year: 1985, genres: ["action", "cult"] },
  { title: "Jagged Edge", year: 1985, genres: ["thriller", "crime"] },
  { title: "Just One of the Guys", year: 1985, genres: ["teen", "comedy", "romance"] },
  { title: "King Solomon's Mines", year: 1985, genres: ["adventure", "action", "comedy"] },
  { title: "Kiss of the Spider Woman", year: 1985, genres: ["drama"] },
  { title: "Krush Groove", year: 1985, genres: ["musical", "drama"] },
  { title: "Ladyhawke", year: 1985, genres: ["fantasy", "adventure", "romance"] },
  { title: "Legend", year: 1985, genres: ["fantasy", "adventure", "cult"] },
  { title: "Lost in America", year: 1985, genres: ["comedy"] },
  { title: "Mad Max Beyond Thunderdome", year: 1985, genres: ["action", "scifi", "adventure"] },
  { title: "Mask", year: 1985, genres: ["drama"] },
  { title: "Murphy's Romance", year: 1985, genres: ["romance", "comedy", "drama"] },
  { title: "My Beautiful Laundrette", year: 1985, genres: ["romance", "drama"] },
  { title: "National Lampoon's European Vacation", year: 1985, genres: ["comedy", "family"] },
  { title: "Once Bitten", year: 1985, genres: ["teen", "comedy", "horror"] },
  { title: "One Magic Christmas", year: 1985, genres: ["family", "fantasy", "drama"] },
  { title: "Out of Africa", year: 1985, genres: ["romance", "drama"] },
  { title: "Pale Rider", year: 1985, genres: ["action", "drama"] },
  { title: "Pee-wee's Big Adventure", year: 1985, genres: ["comedy", "adventure", "cult"] },
  { title: "Perfect", year: 1985, genres: ["romance", "drama"] },
  { title: "Police Academy 2: Their First Assignment", year: 1985, genres: ["comedy"] },
  { title: "Police Story", year: 1985, genres: ["action", "comedy", "crime"] },
  { title: "Porky's Revenge", year: 1985, genres: ["teen", "comedy"] },
  { title: "Prizzi's Honor", year: 1985, genres: ["comedy", "crime", "romance"] },
  { title: "Rainbow Brite and the Star Stealer", year: 1985, genres: ["animation", "family", "fantasy"] },
  { title: "Rambo: First Blood Part II", year: 1985, genres: ["action", "war"] },
  { title: "Ran", year: 1985, genres: ["war", "drama"] },
  { title: "Re-Animator", year: 1985, genres: ["horror", "scifi", "cult"] },
  { title: "Real Genius", year: 1985, genres: ["comedy", "scifi", "teen"] },
  { title: "Red Sonja", year: 1985, genres: ["action", "fantasy", "cult"] },
  { title: "Remo Williams: The Adventure Begins", year: 1985, genres: ["action", "adventure", "cult"] },
  { title: "Return to Oz", year: 1985, genres: ["fantasy", "family", "adventure"] },
  { title: "Rocky IV", year: 1985, genres: ["sports", "drama"] },
  { title: "Runaway Train", year: 1985, genres: ["action", "thriller", "drama"] },
  { title: "Santa Claus: The Movie", year: 1985, genres: ["fantasy", "family", "comedy"] },
  { title: "Sesame Street Presents: Follow That Bird", year: 1985, genres: ["family", "comedy", "musical"] },
  { title: "Silver Bullet", year: 1985, genres: ["horror", "thriller"] },
  { title: "Silverado", year: 1985, genres: ["adventure", "action"] },
  { title: "Spies Like Us", year: 1985, genres: ["comedy", "adventure"] },
  { title: "St. Elmo's Fire", year: 1985, genres: ["drama", "romance", "teen"] },
  { title: "Summer Rental", year: 1985, genres: ["comedy", "family"] },
  { title: "Teen Wolf", year: 1985, genres: ["teen", "comedy", "fantasy"] },
  { title: "The Black Cauldron", year: 1985, genres: ["animation", "fantasy", "family"] },
  { title: "The Breakfast Club", year: 1985, genres: ["teen", "drama", "comedy"] },
  { title: "The Care Bears Movie", year: 1985, genres: ["animation", "family"] },
  { title: "The Color Purple", year: 1985, genres: ["drama"] },
  { title: "The Falcon and the Snowman", year: 1985, genres: ["drama", "thriller"] },
  { title: "The Goonies", year: 1985, genres: ["adventure", "family", "teen"] },
  { title: "The Jewel of the Nile", year: 1985, genres: ["adventure", "romance", "comedy"] },
  { title: "The Journey of Natty Gann", year: 1985, genres: ["adventure", "family", "drama"] },
  { title: "The Last Dragon", year: 1985, genres: ["action", "musical", "cult"] },
  { title: "The Legend of Billie Jean", year: 1985, genres: ["teen", "drama", "cult"] },
  { title: "The Purple Rose of Cairo", year: 1985, genres: ["fantasy", "comedy", "romance"] },
  { title: "The Return of the Living Dead", year: 1985, genres: ["horror", "comedy", "cult"] },
  { title: "The Stuff", year: 1985, genres: ["horror", "comedy", "cult"] },
  { title: "The Sure Thing", year: 1985, genres: ["comedy", "romance", "teen"] },
  { title: "To Live and Die in L.A.", year: 1985, genres: ["action", "crime", "thriller"] },
  { title: "Vision Quest", year: 1985, genres: ["teen", "sports", "drama"] },
  { title: "Volunteers", year: 1985, genres: ["comedy"] },
  { title: "Weird Science", year: 1985, genres: ["teen", "comedy", "scifi"] },
  { title: "Witness", year: 1985, genres: ["thriller", "romance", "crime"] },
  { title: "Young Sherlock Holmes", year: 1985, genres: ["adventure", "fantasy", "family"] },
  { title: "9½ Weeks", year: 1986, genres: ["romance", "drama", "cult"] },
  { title: "A Better Tomorrow", year: 1986, genres: ["action", "crime", "drama"] },
  { title: "About Last Night...", year: 1986, genres: ["romance", "comedy", "drama"] },
  { title: "Absolute Beginners", year: 1986, genres: ["musical", "drama"] },
  { title: "Aliens", year: 1986, genres: ["action", "scifi", "horror"] },
  { title: "An American Tail", year: 1986, genres: ["animation", "family", "musical"] },
  { title: "April Fool's Day", year: 1986, genres: ["horror", "comedy", "teen"] },
  { title: "Back to School", year: 1986, genres: ["comedy"] },
  { title: "Betty Blue", year: 1986, genres: ["romance", "drama", "cult"] },
  { title: "Big Trouble in Little China", year: 1986, genres: ["action", "fantasy", "cult"] },
  { title: "Blue Velvet", year: 1986, genres: ["thriller", "crime", "cult"] },
  { title: "Care Bears Movie II: A New Generation", year: 1986, genres: ["animation", "family"] },
  { title: "Castle in the Sky", year: 1986, genres: ["animation", "fantasy", "adventure"] },
  { title: "Children of a Lesser God", year: 1986, genres: ["romance", "drama"] },
  { title: "Cobra", year: 1986, genres: ["action", "crime"] },
  { title: "Critters", year: 1986, genres: ["scifi", "horror", "comedy"] },
  { title: "Crocodile Dundee", year: 1986, genres: ["adventure", "comedy", "romance"] },
  { title: "Down and Out in Beverly Hills", year: 1986, genres: ["comedy"] },
  { title: "F/X", year: 1986, genres: ["thriller", "action"] },
  { title: "Ferris Bueller's Day Off", year: 1986, genres: ["teen", "comedy"] },
  { title: "Flight of the Navigator", year: 1986, genres: ["scifi", "family", "adventure"] },
  { title: "Friday the 13th Part VI: Jason Lives", year: 1986, genres: ["horror", "comedy", "teen"] },
  { title: "Gung Ho", year: 1986, genres: ["comedy"] },
  { title: "Hannah and Her Sisters", year: 1986, genres: ["comedy", "drama", "romance"] },
  { title: "Heartbreak Ridge", year: 1986, genres: ["war", "action", "drama"] },
  { title: "Heartburn", year: 1986, genres: ["comedy", "drama", "romance"] },
  { title: "Henry: Portrait of a Serial Killer", year: 1986, genres: ["horror", "crime", "cult"] },
  { title: "Highlander", year: 1986, genres: ["action", "fantasy", "cult"] },
  { title: "Hoosiers", year: 1986, genres: ["sports", "drama"] },
  { title: "House", year: 1986, genres: ["horror", "comedy"] },
  { title: "Howard the Duck", year: 1986, genres: ["scifi", "comedy", "cult"] },
  { title: "Iron Eagle", year: 1986, genres: ["action", "teen", "war"] },
  { title: "Jean de Florette", year: 1986, genres: ["drama"] },
  { title: "Jumpin' Jack Flash", year: 1986, genres: ["comedy", "thriller"] },
  { title: "Labyrinth", year: 1986, genres: ["fantasy", "adventure", "musical"] },
  { title: "Legal Eagles", year: 1986, genres: ["comedy", "romance", "thriller"] },
  { title: "Little Shop of Horrors", year: 1986, genres: ["musical", "comedy", "scifi"] },
  { title: "Lucas", year: 1986, genres: ["teen", "drama", "romance"] },
  { title: "Manhunter", year: 1986, genres: ["thriller", "crime"] },
  { title: "Maximum Overdrive", year: 1986, genres: ["scifi", "horror", "cult"] },
  { title: "Mona Lisa", year: 1986, genres: ["crime", "drama"] },
  { title: "My Little Pony: The Movie", year: 1986, genres: ["animation", "family", "fantasy"] },
  { title: "No Retreat, No Surrender", year: 1986, genres: ["action", "sports", "cult"] },
  { title: "One Crazy Summer", year: 1986, genres: ["teen", "comedy", "cult"] },
  { title: "Peggy Sue Got Married", year: 1986, genres: ["fantasy", "comedy", "romance"] },
  { title: "Platoon", year: 1986, genres: ["war", "drama"] },
  { title: "Police Academy 3: Back in Training", year: 1986, genres: ["comedy"] },
  { title: "Poltergeist II: The Other Side", year: 1986, genres: ["horror", "fantasy"] },
  { title: "Pretty in Pink", year: 1986, genres: ["teen", "romance", "drama"] },
  { title: "Psycho III", year: 1986, genres: ["horror", "thriller"] },
  { title: "Rad", year: 1986, genres: ["sports", "teen", "cult"] },
  { title: "River's Edge", year: 1986, genres: ["teen", "drama", "cult"] },
  { title: "Running Scared", year: 1986, genres: ["action", "comedy", "crime"] },
  { title: "Ruthless People", year: 1986, genres: ["comedy", "crime"] },
  { title: "Salvador", year: 1986, genres: ["war", "drama"] },
  { title: "Short Circuit", year: 1986, genres: ["scifi", "comedy", "family"] },
  { title: "Sid and Nancy", year: 1986, genres: ["drama", "musical", "cult"] },
  { title: "Something Wild", year: 1986, genres: ["comedy", "romance", "thriller"] },
  { title: "Soul Man", year: 1986, genres: ["comedy"] },
  { title: "SpaceCamp", year: 1986, genres: ["teen", "adventure", "scifi"] },
  { title: "Stand by Me", year: 1986, genres: ["teen", "drama", "adventure"] },
  { title: "Star Trek IV: The Voyage Home", year: 1986, genres: ["scifi", "comedy", "adventure"] },
  { title: "The Adventures of Milo and Otis", year: 1986, genres: ["family", "adventure"] },
  { title: "The Big Easy", year: 1986, genres: ["romance", "thriller", "crime"] },
  { title: "The Color of Money", year: 1986, genres: ["drama", "sports"] },
  { title: "The Delta Force", year: 1986, genres: ["action", "war"] },
  { title: "The Fly", year: 1986, genres: ["scifi", "horror", "drama"] },
  { title: "The Golden Child", year: 1986, genres: ["comedy", "adventure", "fantasy"] },
  { title: "The Great Mouse Detective", year: 1986, genres: ["animation", "family", "adventure"] },
  { title: "The Hitcher", year: 1986, genres: ["thriller", "horror"] },
  { title: "The Karate Kid Part II", year: 1986, genres: ["teen", "sports", "drama"] },
  { title: "The Mission", year: 1986, genres: ["drama", "adventure"] },
  { title: "The Money Pit", year: 1986, genres: ["comedy"] },
  { title: "The Mosquito Coast", year: 1986, genres: ["drama", "adventure"] },
  { title: "The Name of the Rose", year: 1986, genres: ["crime", "drama"] },
  { title: "The Texas Chainsaw Massacre 2", year: 1986, genres: ["horror", "comedy", "cult"] },
  { title: "The Transformers: The Movie", year: 1986, genres: ["animation", "scifi", "action"] },
  { title: "The Wraith", year: 1986, genres: ["action", "scifi", "cult"] },
  { title: "Thrashin'", year: 1986, genres: ["teen", "sports", "cult"] },
  { title: "Top Gun", year: 1986, genres: ["action", "drama", "romance"] },
  { title: "Troll", year: 1986, genres: ["fantasy", "horror", "cult"] },
  { title: "Under the Cherry Moon", year: 1986, genres: ["musical", "romance", "cult"] },
  { title: "When the Wind Blows", year: 1986, genres: ["animation", "drama", "war"] },
  { title: "Wildcats", year: 1986, genres: ["comedy", "sports"] },
  { title: "Youngblood", year: 1986, genres: ["sports", "drama", "teen"] },
  { title: "¡Three Amigos!", year: 1986, genres: ["comedy", "adventure"] },
  { title: "*batteries not included", year: 1987, genres: ["scifi", "family", "comedy"] },
  { title: "A Nightmare on Elm Street 3: Dream Warriors", year: 1987, genres: ["horror", "teen", "fantasy"] },
  { title: "Adventures in Babysitting", year: 1987, genres: ["teen", "comedy", "adventure"] },
  { title: "Angel Heart", year: 1987, genres: ["fantasy", "horror", "thriller"] },
  { title: "Au Revoir les Enfants", year: 1987, genres: ["war", "drama"] },
  { title: "Babette's Feast", year: 1987, genres: ["drama"] },
  { title: "Baby Boom", year: 1987, genres: ["comedy", "romance"] },
  { title: "Back to the Beach", year: 1987, genres: ["musical", "comedy"] },
  { title: "Bad Taste", year: 1987, genres: ["horror", "comedy", "cult"] },
  { title: "Barfly", year: 1987, genres: ["drama", "comedy", "cult"] },
  { title: "Benji the Hunted", year: 1987, genres: ["family", "adventure"] },
  { title: "Beverly Hills Cop II", year: 1987, genres: ["action", "comedy", "crime"] },
  { title: "Blind Date", year: 1987, genres: ["comedy", "romance"] },
  { title: "Broadcast News", year: 1987, genres: ["romance", "comedy", "drama"] },
  { title: "Can't Buy Me Love", year: 1987, genres: ["teen", "romance", "comedy"] },
  { title: "Creepshow 2", year: 1987, genres: ["horror", "cult"] },
  { title: "Cry Freedom", year: 1987, genres: ["drama"] },
  { title: "Dirty Dancing", year: 1987, genres: ["romance", "drama", "musical"] },
  { title: "Dragnet", year: 1987, genres: ["comedy", "crime"] },
  { title: "Empire of the Sun", year: 1987, genres: ["war", "drama"] },
  { title: "Ernest Goes to Camp", year: 1987, genres: ["comedy", "family"] },
  { title: "Evil Dead II", year: 1987, genres: ["horror", "comedy", "cult"] },
  { title: "Fatal Attraction", year: 1987, genres: ["thriller", "drama", "romance"] },
  { title: "Full Metal Jacket", year: 1987, genres: ["war", "drama"] },
  { title: "Good Morning, Vietnam", year: 1987, genres: ["comedy", "war", "drama"] },
  { title: "Hamburger Hill", year: 1987, genres: ["war", "drama"] },
  { title: "Harry and the Hendersons", year: 1987, genres: ["fantasy", "family", "comedy"] },
  { title: "Hellraiser", year: 1987, genres: ["horror", "fantasy"] },
  { title: "Hope and Glory", year: 1987, genres: ["war", "drama", "comedy"] },
  { title: "House II: The Second Story", year: 1987, genres: ["horror", "comedy", "fantasy"] },
  { title: "House of Games", year: 1987, genres: ["thriller", "crime"] },
  { title: "Innerspace", year: 1987, genres: ["scifi", "comedy", "adventure"] },
  { title: "Ishtar", year: 1987, genres: ["comedy", "adventure"] },
  { title: "Jaws: The Revenge", year: 1987, genres: ["horror", "thriller"] },
  { title: "La Bamba", year: 1987, genres: ["musical", "drama", "romance"] },
  { title: "Less Than Zero", year: 1987, genres: ["drama", "teen"] },
  { title: "Lethal Weapon", year: 1987, genres: ["action", "crime", "thriller"] },
  { title: "Like Father Like Son", year: 1987, genres: ["comedy", "fantasy", "teen"] },
  { title: "Mannequin", year: 1987, genres: ["fantasy", "romance", "comedy"] },
  { title: "Masters of the Universe", year: 1987, genres: ["action", "fantasy", "cult"] },
  { title: "Maurice", year: 1987, genres: ["romance", "drama"] },
  { title: "Moonstruck", year: 1987, genres: ["romance", "comedy", "drama"] },
  { title: "Near Dark", year: 1987, genres: ["horror", "romance", "cult"] },
  { title: "No Way Out", year: 1987, genres: ["thriller", "crime"] },
  { title: "North Shore", year: 1987, genres: ["teen", "sports", "romance"] },
  { title: "Outrageous Fortune", year: 1987, genres: ["comedy", "action"] },
  { title: "Over the Top", year: 1987, genres: ["drama", "sports", "action"] },
  { title: "Overboard", year: 1987, genres: ["romance", "comedy"] },
  { title: "Pelle the Conqueror", year: 1987, genres: ["drama"] },
  { title: "Planes, Trains and Automobiles", year: 1987, genres: ["comedy"] },
  { title: "Police Academy 4: Citizens on Patrol", year: 1987, genres: ["comedy"] },
  { title: "Predator", year: 1987, genres: ["action", "scifi", "horror"] },
  { title: "Prince of Darkness", year: 1987, genres: ["horror", "scifi"] },
  { title: "Radio Days", year: 1987, genres: ["comedy", "drama"] },
  { title: "Raising Arizona", year: 1987, genres: ["comedy", "crime", "cult"] },
  { title: "Revenge of the Nerds II: Nerds in Paradise", year: 1987, genres: ["comedy", "teen"] },
  { title: "RoboCop", year: 1987, genres: ["action", "scifi", "crime"] },
  { title: "Roxanne", year: 1987, genres: ["romance", "comedy"] },
  { title: "Some Kind of Wonderful", year: 1987, genres: ["teen", "romance", "drama"] },
  { title: "Spaceballs", year: 1987, genres: ["comedy", "scifi", "cult"] },
  { title: "Stakeout", year: 1987, genres: ["action", "comedy", "crime"] },
  { title: "Summer School", year: 1987, genres: ["teen", "comedy"] },
  { title: "Superman IV: The Quest for Peace", year: 1987, genres: ["action", "fantasy"] },
  { title: "Teen Wolf Too", year: 1987, genres: ["teen", "comedy", "fantasy"] },
  { title: "The Brave Little Toaster", year: 1987, genres: ["animation", "family", "adventure"] },
  { title: "The Care Bears Adventure in Wonderland", year: 1987, genres: ["animation", "family", "fantasy"] },
  { title: "The Chipmunk Adventure", year: 1987, genres: ["animation", "family", "musical"] },
  { title: "The Garbage Pail Kids Movie", year: 1987, genres: ["comedy", "family", "cult"] },
  { title: "The Last Emperor", year: 1987, genres: ["drama"] },
  { title: "The Living Daylights", year: 1987, genres: ["action", "adventure", "thriller"] },
  { title: "The Lost Boys", year: 1987, genres: ["horror", "teen", "comedy"] },
  { title: "The Monster Squad", year: 1987, genres: ["horror", "comedy", "cult"] },
  { title: "The Princess Bride", year: 1987, genres: ["adventure", "fantasy", "romance"] },
  { title: "The Principal", year: 1987, genres: ["drama", "action"] },
  { title: "The Running Man", year: 1987, genres: ["action", "scifi", "thriller"] },
  { title: "The Secret of My Success", year: 1987, genres: ["comedy", "romance"] },
  { title: "The Stepfather", year: 1987, genres: ["thriller", "horror"] },
  { title: "The Untouchables", year: 1987, genres: ["crime", "drama", "action"] },
  { title: "The Witches of Eastwick", year: 1987, genres: ["fantasy", "comedy", "horror"] },
  { title: "Three Men and a Baby", year: 1987, genres: ["comedy", "family"] },
  { title: "Three O'Clock High", year: 1987, genres: ["teen", "comedy", "cult"] },
  { title: "Throw Momma from the Train", year: 1987, genres: ["comedy", "crime"] },
  { title: "Tin Men", year: 1987, genres: ["comedy", "drama"] },
  { title: "Wall Street", year: 1987, genres: ["drama", "crime"] },
  { title: "Wings of Desire", year: 1987, genres: ["fantasy", "drama", "romance"] },
  { title: "Withnail and I", year: 1987, genres: ["comedy", "cult", "drama"] },
  { title: "976-EVIL", year: 1988, genres: ["horror", "teen"] },
  { title: "A Cry in the Dark", year: 1988, genres: ["drama"] },
  { title: "A Fish Called Wanda", year: 1988, genres: ["comedy", "crime", "romance"] },
  { title: "A Nightmare on Elm Street 4: The Dream Master", year: 1988, genres: ["horror", "teen"] },
  { title: "Above the Law", year: 1988, genres: ["action", "crime"] },
  { title: "Action Jackson", year: 1988, genres: ["action", "comedy", "cult"] },
  { title: "Akira", year: 1988, genres: ["animation", "scifi", "action"] },
  { title: "Alien Nation", year: 1988, genres: ["scifi", "action", "crime"] },
  { title: "Beaches", year: 1988, genres: ["drama", "romance"] },
  { title: "Beetlejuice", year: 1988, genres: ["fantasy", "comedy", "horror"] },
  { title: "Big", year: 1988, genres: ["comedy", "fantasy", "drama"] },
  { title: "Big Business", year: 1988, genres: ["comedy"] },
  { title: "Big Top Pee-wee", year: 1988, genres: ["comedy", "family"] },
  { title: "Biloxi Blues", year: 1988, genres: ["comedy", "drama", "war"] },
  { title: "Bird", year: 1988, genres: ["drama", "musical"] },
  { title: "Bloodsport", year: 1988, genres: ["action", "sports", "cult"] },
  { title: "Bright Lights, Big City", year: 1988, genres: ["drama"] },
  { title: "Bull Durham", year: 1988, genres: ["romance", "comedy", "sports"] },
  { title: "Caddyshack II", year: 1988, genres: ["comedy", "sports"] },
  { title: "Child's Play", year: 1988, genres: ["horror", "thriller"] },
  { title: "Cinema Paradiso", year: 1988, genres: ["drama", "romance"] },
  { title: "Clean and Sober", year: 1988, genres: ["drama"] },
  { title: "Cocktail", year: 1988, genres: ["romance", "drama"] },
  { title: "Cocoon: The Return", year: 1988, genres: ["scifi", "drama", "comedy"] },
  { title: "Colors", year: 1988, genres: ["crime", "drama", "action"] },
  { title: "Coming to America", year: 1988, genres: ["comedy", "romance"] },
  { title: "Critters 2: The Main Course", year: 1988, genres: ["horror", "comedy", "scifi"] },
  { title: "Crocodile Dundee II", year: 1988, genres: ["adventure", "comedy"] },
  { title: "Crossing Delancey", year: 1988, genres: ["romance", "comedy"] },
  { title: "D.O.A.", year: 1988, genres: ["thriller", "crime"] },
  { title: "Dangerous Liaisons", year: 1988, genres: ["drama", "romance"] },
  { title: "Dead Ringers", year: 1988, genres: ["horror", "drama", "thriller"] },
  { title: "Die Hard", year: 1988, genres: ["action", "thriller"] },
  { title: "Dirty Rotten Scoundrels", year: 1988, genres: ["comedy", "crime"] },
  { title: "Earth Girls Are Easy", year: 1988, genres: ["scifi", "comedy", "musical"] },
  { title: "Eight Men Out", year: 1988, genres: ["sports", "drama"] },
  { title: "Elvira: Mistress of the Dark", year: 1988, genres: ["comedy", "horror", "cult"] },
  { title: "Ernest Saves Christmas", year: 1988, genres: ["comedy", "family"] },
  { title: "For Keeps", year: 1988, genres: ["teen", "drama", "romance"] },
  { title: "Frantic", year: 1988, genres: ["thriller"] },
  { title: "Friday the 13th Part VII: The New Blood", year: 1988, genres: ["horror", "teen"] },
  { title: "Fright Night Part 2", year: 1988, genres: ["horror", "comedy"] },
  { title: "Funny Farm", year: 1988, genres: ["comedy"] },
  { title: "Gorillas in the Mist", year: 1988, genres: ["drama"] },
  { title: "Grave of the Fireflies", year: 1988, genres: ["animation", "war", "drama"] },
  { title: "Hairspray", year: 1988, genres: ["teen", "musical", "cult"] },
  { title: "Halloween 4: The Return of Michael Myers", year: 1988, genres: ["horror", "thriller"] },
  { title: "Hellbound: Hellraiser II", year: 1988, genres: ["horror", "fantasy"] },
  { title: "Killer Klowns from Outer Space", year: 1988, genres: ["scifi", "horror", "cult"] },
  { title: "License to Drive", year: 1988, genres: ["teen", "comedy"] },
  { title: "Mac and Me", year: 1988, genres: ["scifi", "family", "cult"] },
  { title: "Maniac Cop", year: 1988, genres: ["horror", "action", "cult"] },
  { title: "Married to the Mob", year: 1988, genres: ["comedy", "crime", "romance"] },
  { title: "Midnight Run", year: 1988, genres: ["action", "comedy", "crime"] },
  { title: "Mississippi Burning", year: 1988, genres: ["crime", "drama", "thriller"] },
  { title: "Moonwalker", year: 1988, genres: ["musical", "fantasy", "cult"] },
  { title: "My Neighbor Totoro", year: 1988, genres: ["animation", "fantasy", "family"] },
  { title: "My Stepmother Is an Alien", year: 1988, genres: ["scifi", "comedy", "romance"] },
  { title: "Mystic Pizza", year: 1988, genres: ["romance", "comedy", "drama"] },
  { title: "Night of the Demons", year: 1988, genres: ["horror", "teen", "cult"] },
  { title: "Oliver & Company", year: 1988, genres: ["animation", "family", "musical"] },
  { title: "Phantasm II", year: 1988, genres: ["horror", "scifi", "cult"] },
  { title: "Police Academy 5: Assignment Miami Beach", year: 1988, genres: ["comedy"] },
  { title: "Poltergeist III", year: 1988, genres: ["horror", "fantasy"] },
  { title: "Pumpkinhead", year: 1988, genres: ["horror", "fantasy", "cult"] },
  { title: "Punchline", year: 1988, genres: ["comedy", "drama"] },
  { title: "Rain Man", year: 1988, genres: ["drama"] },
  { title: "Rambo III", year: 1988, genres: ["action", "war"] },
  { title: "Red Heat", year: 1988, genres: ["action", "comedy", "crime"] },
  { title: "Return of the Living Dead Part II", year: 1988, genres: ["horror", "comedy"] },
  { title: "Running on Empty", year: 1988, genres: ["drama"] },
  { title: "Scrooged", year: 1988, genres: ["fantasy", "comedy"] },
  { title: "She's Having a Baby", year: 1988, genres: ["comedy", "romance", "drama"] },
  { title: "Shoot to Kill", year: 1988, genres: ["thriller", "action"] },
  { title: "Short Circuit 2", year: 1988, genres: ["scifi", "comedy", "family"] },
  { title: "Sleepaway Camp II: Unhappy Campers", year: 1988, genres: ["horror", "comedy", "cult"] },
  { title: "Stand and Deliver", year: 1988, genres: ["drama"] },
  { title: "Talk Radio", year: 1988, genres: ["drama"] },
  { title: "Tequila Sunrise", year: 1988, genres: ["thriller", "romance", "crime"] },
  { title: "The Accidental Tourist", year: 1988, genres: ["drama", "romance"] },
  { title: "The Accused", year: 1988, genres: ["drama", "crime"] },
  { title: "The Adventures of Baron Munchausen", year: 1988, genres: ["fantasy", "adventure", "comedy"] },
  { title: "The Bear", year: 1988, genres: ["adventure", "family", "drama"] },
  { title: "The Blob", year: 1988, genres: ["scifi", "horror"] },
  { title: "The Dead Pool", year: 1988, genres: ["action", "crime", "thriller"] },
  { title: "The Great Outdoors", year: 1988, genres: ["comedy", "family"] },
  { title: "The Land Before Time", year: 1988, genres: ["animation", "family", "adventure"] },
  { title: "The Last Temptation of Christ", year: 1988, genres: ["drama"] },
  { title: "The Naked Gun: From the Files of Police Squad!", year: 1988, genres: ["comedy", "crime"] },
  { title: "The New Adventures of Pippi Longstocking", year: 1988, genres: ["family", "adventure", "musical"] },
  { title: "The Presidio", year: 1988, genres: ["thriller", "crime"] },
  { title: "The Serpent and the Rainbow", year: 1988, genres: ["horror", "thriller"] },
  { title: "The Seventh Sign", year: 1988, genres: ["fantasy", "horror", "thriller"] },
  { title: "The Unbearable Lightness of Being", year: 1988, genres: ["romance", "drama"] },
  { title: "The Vanishing", year: 1988, genres: ["thriller", "horror", "drama"] },
  { title: "They Live", year: 1988, genres: ["action", "scifi", "cult"] },
  { title: "Torch Song Trilogy", year: 1988, genres: ["drama", "comedy", "romance"] },
  { title: "Tucker: The Man and His Dream", year: 1988, genres: ["drama"] },
  { title: "Twins", year: 1988, genres: ["comedy", "scifi"] },
  { title: "Vice Versa", year: 1988, genres: ["comedy", "fantasy", "family"] },
  { title: "Who Framed Roger Rabbit", year: 1988, genres: ["animation", "comedy", "adventure"] },
  { title: "Willow", year: 1988, genres: ["fantasy", "adventure", "family"] },
  { title: "Working Girl", year: 1988, genres: ["romance", "comedy", "drama"] },
  { title: "Young Guns", year: 1988, genres: ["action", "adventure"] },
  { title: "A Nightmare on Elm Street 5: The Dream Child", year: 1989, genres: ["horror", "teen"] },
  { title: "All Dogs Go to Heaven", year: 1989, genres: ["animation", "fantasy", "family"] },
  { title: "Always", year: 1989, genres: ["fantasy", "romance", "drama"] },
  { title: "Back to the Future Part II", year: 1989, genres: ["scifi", "adventure", "comedy"] },
  { title: "Batman", year: 1989, genres: ["action", "fantasy", "crime"] },
  { title: "Best of the Best", year: 1989, genres: ["action", "sports"] },
  { title: "Bill & Ted's Excellent Adventure", year: 1989, genres: ["teen", "comedy", "scifi"] },
  { title: "Black Rain", year: 1989, genres: ["action", "crime", "thriller"] },
  { title: "Born on the Fourth of July", year: 1989, genres: ["war", "drama"] },
  { title: "Casualties of War", year: 1989, genres: ["war", "drama"] },
  { title: "Crimes and Misdemeanors", year: 1989, genres: ["drama", "comedy", "crime"] },
  { title: "Cyborg", year: 1989, genres: ["action", "scifi", "cult"] },
  { title: "Dead Calm", year: 1989, genres: ["thriller"] },
  { title: "Dead Poets Society", year: 1989, genres: ["drama", "teen"] },
  { title: "Do the Right Thing", year: 1989, genres: ["drama", "comedy"] },
  { title: "Dream a Little Dream", year: 1989, genres: ["teen", "fantasy", "comedy"] },
  { title: "Driving Miss Daisy", year: 1989, genres: ["drama", "comedy"] },
  { title: "Drugstore Cowboy", year: 1989, genres: ["crime", "drama", "cult"] },
  { title: "Enemies, A Love Story", year: 1989, genres: ["drama", "romance"] },
  { title: "Family Business", year: 1989, genres: ["crime", "drama", "comedy"] },
  { title: "Field of Dreams", year: 1989, genres: ["fantasy", "drama", "sports"] },
  { title: "Fletch Lives", year: 1989, genres: ["comedy", "crime"] },
  { title: "Friday the 13th Part VIII: Jason Takes Manhattan", year: 1989, genres: ["horror", "teen"] },
  { title: "Ghostbusters II", year: 1989, genres: ["comedy", "fantasy", "adventure"] },
  { title: "Gleaming the Cube", year: 1989, genres: ["teen", "action", "thriller"] },
  { title: "Glory", year: 1989, genres: ["war", "drama"] },
  { title: "Great Balls of Fire!", year: 1989, genres: ["musical", "drama"] },
  { title: "Halloween 5: The Revenge of Michael Myers", year: 1989, genres: ["horror", "thriller"] },
  { title: "Harlem Nights", year: 1989, genres: ["comedy", "crime"] },
  { title: "Heathers", year: 1989, genres: ["teen", "comedy", "cult"] },
  { title: "Henry V", year: 1989, genres: ["war", "drama"] },
  { title: "Honey, I Shrunk the Kids", year: 1989, genres: ["family", "adventure", "comedy"] },
  { title: "Indiana Jones and the Last Crusade", year: 1989, genres: ["action", "adventure", "fantasy"] },
  { title: "K-9", year: 1989, genres: ["comedy", "action", "crime"] },
  { title: "Kickboxer", year: 1989, genres: ["action", "sports"] },
  { title: "Kiki's Delivery Service", year: 1989, genres: ["animation", "fantasy", "family"] },
  { title: "Lean on Me", year: 1989, genres: ["drama"] },
  { title: "Lethal Weapon 2", year: 1989, genres: ["action", "crime", "thriller"] },
  { title: "Licence to Kill", year: 1989, genres: ["action", "adventure", "thriller"] },
  { title: "Little Monsters", year: 1989, genres: ["family", "fantasy", "comedy"] },
  { title: "Look Who's Talking", year: 1989, genres: ["comedy", "romance", "family"] },
  { title: "Loverboy", year: 1989, genres: ["comedy", "romance", "teen"] },
  { title: "Major League", year: 1989, genres: ["comedy", "sports"] },
  { title: "My Left Foot", year: 1989, genres: ["drama"] },
  { title: "National Lampoon's Christmas Vacation", year: 1989, genres: ["comedy", "family"] },
  { title: "Parenthood", year: 1989, genres: ["comedy", "drama", "family"] },
  { title: "Pet Sematary", year: 1989, genres: ["horror", "drama"] },
  { title: "Police Academy 6: City Under Siege", year: 1989, genres: ["comedy"] },
  { title: "Prancer", year: 1989, genres: ["family", "drama", "fantasy"] },
  { title: "Puppet Master", year: 1989, genres: ["horror", "fantasy", "cult"] },
  { title: "Road House", year: 1989, genres: ["action", "cult"] },
  { title: "Say Anything...", year: 1989, genres: ["teen", "romance", "drama"] },
  { title: "Sea of Love", year: 1989, genres: ["thriller", "romance", "crime"] },
  { title: "See No Evil, Hear No Evil", year: 1989, genres: ["comedy", "crime"] },
  { title: "sex, lies, and videotape", year: 1989, genres: ["drama", "romance"] },
  { title: "Shag", year: 1989, genres: ["teen", "comedy", "romance"] },
  { title: "She-Devil", year: 1989, genres: ["comedy"] },
  { title: "Shirley Valentine", year: 1989, genres: ["comedy", "drama", "romance"] },
  { title: "Shocker", year: 1989, genres: ["horror", "comedy"] },
  { title: "Skin Deep", year: 1989, genres: ["comedy"] },
  { title: "Star Trek V: The Final Frontier", year: 1989, genres: ["scifi", "adventure"] },
  { title: "Steel Magnolias", year: 1989, genres: ["drama", "comedy", "romance"] },
  { title: "Tango & Cash", year: 1989, genres: ["action", "comedy", "crime"] },
  { title: "Tap", year: 1989, genres: ["musical", "drama"] },
  { title: "Teen Witch", year: 1989, genres: ["teen", "fantasy", "cult"] },
  { title: "The 'Burbs", year: 1989, genres: ["comedy", "horror", "cult"] },
  { title: "The Abyss", year: 1989, genres: ["scifi", "adventure", "thriller"] },
  { title: "The Dream Team", year: 1989, genres: ["comedy"] },
  { title: "The Fabulous Baker Boys", year: 1989, genres: ["romance", "drama", "musical"] },
  { title: "The Fly II", year: 1989, genres: ["scifi", "horror"] },
  { title: "The Karate Kid Part III", year: 1989, genres: ["teen", "sports", "drama"] },
  { title: "The Killer", year: 1989, genres: ["action", "crime", "cult"] },
  { title: "The Little Mermaid", year: 1989, genres: ["animation", "fantasy", "musical"] },
  { title: "The War of the Roses", year: 1989, genres: ["comedy", "drama"] },
  { title: "The Wizard", year: 1989, genres: ["family", "adventure", "comedy"] },
  { title: "Three Fugitives", year: 1989, genres: ["comedy", "crime"] },
  { title: "Troop Beverly Hills", year: 1989, genres: ["comedy", "family"] },
  { title: "Turner & Hooch", year: 1989, genres: ["comedy", "crime", "family"] },
  { title: "UHF", year: 1989, genres: ["comedy", "cult"] },
  { title: "Uncle Buck", year: 1989, genres: ["comedy", "family"] },
  { title: "Valmont", year: 1989, genres: ["drama", "romance"] },
  { title: "Warlock", year: 1989, genres: ["fantasy", "horror", "cult"] },
  { title: "Weekend at Bernie's", year: 1989, genres: ["comedy", "cult"] },
  { title: "When Harry Met Sally...", year: 1989, genres: ["romance", "comedy"] },
];

/**
 * Three picks for a night: genre-rotated and never repeating a title from
 * `recentTitles` (the last 8 nights). `seed` should be stable per night so a
 * retried tick lands on the same three. Optional `theme` restricts to a genre
 * (e.g. 'horror' in late October); falls back to the whole catalog if the
 * themed pool is too small.
 */
export function pickThree(catalog, { recentTitles = [], seed = 0, theme = null } = {}) {
  const recent = new Set(recentTitles.map(t => String(t).toLowerCase()));
  let pool = catalog.filter(f => !recent.has(f.title.toLowerCase()));
  if (theme) {
    const themed = pool.filter(f => f.genres.includes(theme));
    if (themed.length >= 12) pool = themed;
  }
  // Deterministic shuffle (mulberry32) so the same night always yields the same three.
  let a = (seed >>> 0) || 1;
  const rnd = () => { a += 0x6D2B79F5; let t = a; t = Math.imul(t ^ (t >>> 15), t | 1); t ^= t + Math.imul(t ^ (t >>> 7), t | 61); return ((t ^ (t >>> 14)) >>> 0) / 4294967296; };
  const shuffled = pool.map(f => [rnd(), f]).sort((x, y) => x[0] - y[0]).map(x => x[1]);
  // Spread genres: avoid three of the same primary genre unless themed.
  const picks = [];
  const primaries = new Set();
  for (const f of shuffled) {
    const p = f.genres[0];
    if (!theme && primaries.has(p) && picks.length < 2) continue;
    picks.push(f); primaries.add(p);
    if (picks.length === 3) break;
  }
  while (picks.length < 3 && shuffled.length) { const f = shuffled.find(x => !picks.includes(x)); if (!f) break; picks.push(f); }
  return picks;
}
